module.exports = __webpack_public_path__ + "img/ahb-background.db2e1794.jpg";